import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Reconocer la verdad: me cuesta pedir",
    opening: localizedGenderNode(
      [
      "Hoy dejo de decirme “no es importante”. Admito: me cuesta expresar lo que necesito."
    ],
      [
      "Hoy dejo de decirme “no es importante”. Admito: me cuesta expresar lo que necesito."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Esta dificultad intenta protegerme”."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración lenta.",
      "Me digo en silencio: “Esta dificultad intenta protegerme”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué me cuesta pedir en esta relación?\n[Escribo aquí]",
      "¿Qué temo que ocurra si lo pido?\n[Escribo aquí]",
      "¿Dónde siento este miedo en el cuerpo?\n[Escribo aquí]"
    ],
      [
      "¿Qué me cuesta pedir en esta relación?\n[Escribo aquí]",
      "¿Qué temo que ocurra si lo pido?\n[Escribo aquí]",
      "¿Dónde siento este miedo en el cuerpo?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La dificultad para pedir es señal de sensibilidad, no de debilidad."
    ],
      [
      "Cierre",
      "La dificultad para pedir es señal de sensibilidad, no de debilidad."
    ]
    ),
    action: localizedGenderNode(
      "Observo una necesidad mía, sin expresarla aún. Solo observar.",
      "Observo una necesidad mía, sin expresarla aún. Solo observar."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "Lo que aprendí en el pasado sobre pedir",
    opening: localizedGenderNode(
      [
      "Hoy entiendo de dónde viene esto, sin culparme."
    ],
      [
      "Hoy entiendo de dónde viene esto, sin culparme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Esto se aprendió — no soy yo”."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Esto se aprendió — no soy yo”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué ocurrió en el pasado cuando pedí algo importante?\n[Escribo aquí]",
      "¿Qué mensaje tomé de eso sobre necesidades y límites?\n[Escribo aquí]",
      "¿Qué verdad suave puede existir hoy, aunque el pasado haya dolido?\n[Escribo aquí]"
    ],
      [
      "¿Qué ocurrió en el pasado cuando pedí algo importante?\n[Escribo aquí]",
      "¿Qué mensaje tomé de eso sobre necesidades y límites?\n[Escribo aquí]",
      "¿Qué verdad suave puede existir hoy, aunque el pasado haya dolido?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El pasado me explica, pero no tiene que controlarme."
    ],
      [
      "Cierre",
      "El pasado me explica, pero no tiene que controlarme."
    ]
    ),
    action: localizedGenderNode(
      "Cuando surge el pensamiento “mejor callar” — una respiración + “esto es antiguo”.",
      "Cuando surge el pensamiento “mejor callar” — una respiración + “esto es antiguo”."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "El miedo a ser “demasiado”",
    opening: localizedGenderNode(
      [
      "Hoy me encuentro con el miedo a ser una carga."
    ],
      [
      "Hoy me encuentro con el miedo a ser una carga."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo siento que soy “demasiado”?\n[Escribo aquí]",
      "¿Qué hago con mis necesidades en ese momento?\n[Escribo aquí]",
      "Si un amigo se sintiera así, ¿qué le diría?\n[Escribo aquí]"
    ],
      [
      "¿Cuándo siento que soy “demasiado”?\n[Escribo aquí]",
      "¿Qué hago con mis necesidades en ese momento?\n[Escribo aquí]",
      "Si un amigo se sintiera así, ¿qué le diría?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una necesidad no me convierte en una carga. Me hace humano."
    ],
      [
      "Cierre",
      "Una necesidad no me convierte en una carga. Me hace humano."
    ]
    ),
    action: localizedGenderNode(
      "Me digo una frase que honra una necesidad.",
      "Me digo una frase que honra una necesidad."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "El silencio como hábito",
    opening: localizedGenderNode(
      [
      "Hoy veo cómo el silencio protege… y cómo hiere."
    ],
      [
      "Hoy veo cómo el silencio protege… y cómo hiere."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo me callo en lugar de hablar?\n[Escribo aquí]",
      "¿Qué gano con el silencio a corto plazo?\n[Escribo aquí]",
      "¿Cuál es el costo a largo plazo?\n[Escribo aquí]"
    ],
      [
      "¿Cuándo me callo en lugar de hablar?\n[Escribo aquí]",
      "¿Qué gano con el silencio a corto plazo?\n[Escribo aquí]",
      "¿Cuál es el costo a largo plazo?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El silencio protege un momento, pero cobra un precio duradero."
    ],
      [
      "Cierre",
      "El silencio protege un momento, pero cobra un precio duradero."
    ]
    ),
    action: localizedGenderNode(
      "Observo un momento de silencio, sin juzgar.",
      "Observo un momento de silencio, sin juzgar."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Un límite no es una amenaza",
    opening: localizedGenderNode(
      [
      "Hoy aprendo que un límite no es un ataque."
    ],
      [
      "Hoy aprendo que un límite no es un ataque."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Un límite protege la relación, no la destruye”."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Un límite protege la relación, no la destruye”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué límite me cuesta especialmente poner?\n[Escribo aquí]",
      "¿Qué temo que ocurra si lo pongo?\n[Escribo aquí]",
      "¿Cómo se ve un límite suave y no agresivo?\n[Escribo aquí]"
    ],
      [
      "¿Qué límite me cuesta especialmente poner?\n[Escribo aquí]",
      "¿Qué temo que ocurra si lo pongo?\n[Escribo aquí]",
      "¿Cómo se ve un límite suave y no agresivo?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Un límite es información, no un ultimátum."
    ],
      [
      "Cierre",
      "Un límite es información, no un ultimátum."
    ]
    ),
    action: localizedGenderNode(
      "Escribo un límite solo para mí, en papel.",
      "Escribo un límite solo para mí, en papel."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "Separar una petición de una exigencia",
    opening: localizedGenderNode(
      [
      "Hoy aprendo a pedir sin controlar."
    ],
      [
      "Hoy aprendo a pedir sin controlar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo suena una petición cuando estoy bajo presión?\n[Escribo aquí]",
      "¿Cómo suena una petición cuando estoy calmado/a?\n[Escribo aquí]",
      "¿Cuál versión se siente más conectada?\n[Escribo aquí]"
    ],
      [
      "¿Cómo suena una petición cuando estoy bajo presión?\n[Escribo aquí]",
      "¿Cómo suena una petición cuando estoy calmado/a?\n[Escribo aquí]",
      "¿Cuál versión se siente más conectada?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Una petición permite elección. Una exigencia crea miedo."
    ],
      [
      "Cierre",
      "Una petición permite elección. Una exigencia crea miedo."
    ]
    ),
    action: localizedGenderNode(
      "Practico formular una petición calmada, solo para mí.",
      "Practico formular una petición calmada, solo para mí."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Lo que pasa en mí cuando no me escuchan",
    opening: localizedGenderNode(
      [
      "Hoy escucho el dolor sin minimizarlo."
    ],
      [
      "Hoy escucho el dolor sin minimizarlo."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo me siento cuando no me escuchan?\n[Escribo aquí]",
      "¿Qué hago con ese sentimiento?\n[Escribo aquí]",
      "¿Qué necesitaba oír entonces?\n[Escribo aquí]"
    ],
      [
      "¿Cómo me siento cuando no me escuchan?\n[Escribo aquí]",
      "¿Qué hago con ese sentimiento?\n[Escribo aquí]",
      "¿Qué necesitaba oír entonces?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El dolor que no se expresa se queda en el cuerpo."
    ],
      [
      "Cierre",
      "El dolor que no se expresa se queda en el cuerpo."
    ]
    ),
    action: localizedGenderNode(
      "Mano en el pecho + una respiración cuando aparece el dolor.",
      "Mano en el pecho + una respiración cuando aparece el dolor."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Miedo al rechazo",
    opening: localizedGenderNode(
      [
      "Hoy me encuentro con el miedo a un “no”."
    ],
      [
      "Hoy me encuentro con el miedo a un “no”."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “El rechazo es una posibilidad, no un veredicto”."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “El rechazo es una posibilidad, no un veredicto”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué imagino que ocurrirá si dicen “no”?\n[Escribo aquí]",
      "¿Ha ocurrido antes — y qué pasó realmente?\n[Escribo aquí]",
      "¿Qué verdad puedo elegir incluso si hay un “no”?\n[Escribo aquí]"
    ],
      [
      "¿Qué imagino que ocurrirá si dicen “no”?\n[Escribo aquí]",
      "¿Ha ocurrido antes — y qué pasó realmente?\n[Escribo aquí]",
      "¿Qué verdad puedo elegir incluso si hay un “no”?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Sigo siendo valioso/a aunque una petición no sea aceptada."
    ],
      [
      "Cierre",
      "Sigo siendo valioso/a aunque una petición no sea aceptada."
    ]
    ),
    action: localizedGenderNode(
      "Respiro un minuto con la posibilidad del “no”.",
      "Respiro un minuto con la posibilidad del “no”."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Hacerme cargo de mis necesidades",
    opening: localizedGenderNode(
      [
      "Hoy dejo de esperar que otros me adivinen."
    ],
      [
      "Hoy dejo de esperar que otros me adivinen."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué necesidad estoy esperando que la otra persona entienda sola?\n[Escribo aquí]",
      "¿Cómo se siente esperar sin decirlo?\n[Escribo aquí]",
      "¿Qué pequeño paso de responsabilidad puedo dar?\n[Escribo aquí]"
    ],
      [
      "¿Qué necesidad estoy esperando que la otra persona entienda sola?\n[Escribo aquí]",
      "¿Cómo se siente esperar sin decirlo?\n[Escribo aquí]",
      "¿Qué pequeño paso de responsabilidad puedo dar?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Expresar una necesidad es responsabilidad, no debilidad."
    ],
      [
      "Cierre",
      "Expresar una necesidad es responsabilidad, no debilidad."
    ]
    ),
    action: localizedGenderNode(
      "Escribo una necesidad en una frase simple.",
      "Escribo una necesidad en una frase simple."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Hablar en primera persona",
    opening: localizedGenderNode(
      [
      "Hoy hablo sin culpar."
    ],
      [
      "Hoy hablo sin culpar."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cómo suena cuando culpo?\n[Escribo aquí]",
      "¿Cómo suena lo mismo en primera persona (“yo siento / yo necesito”)?\n[Escribo aquí]",
      "¿Cuál versión se siente más segura para mí?\n[Escribo aquí]"
    ],
      [
      "¿Cómo suena cuando culpo?\n[Escribo aquí]",
      "¿Cómo suena lo mismo en primera persona (“yo siento / yo necesito”)?\n[Escribo aquí]",
      "¿Cuál versión se siente más segura para mí?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El lenguaje en primera persona abre la escucha."
    ],
      [
      "Cierre",
      "El lenguaje en primera persona abre la escucha."
    ]
    ),
    action: localizedGenderNode(
      "Practico una frase en primera persona.",
      "Practico una frase en primera persona."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Elegir el momento adecuado",
    opening: localizedGenderNode(
      [
      "Hoy elijo un momento que me respete."
    ],
      [
      "Hoy elijo un momento que me respete."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Cuándo suelo expresar mis necesidades?\n[Escribo aquí]",
      "¿Cómo influye eso en la respuesta?\n[Escribo aquí]",
      "¿Cuándo podría ser un momento un poco más seguro?\n[Escribo aquí]"
    ],
      [
      "¿Cuándo suelo expresar mis necesidades?\n[Escribo aquí]",
      "¿Cómo influye eso en la respuesta?\n[Escribo aquí]",
      "¿Cuándo podría ser un momento un poco más seguro?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "El momento también es parte de un límite."
    ],
      [
      "Cierre",
      "El momento también es parte de un límite."
    ]
    ),
    action: localizedGenderNode(
      "Elijo un momento futuro para una conversación, sin actuar aún.",
      "Elijo un momento futuro para una conversación, sin actuar aún."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Tolerar la incomodidad",
    opening: localizedGenderNode(
      [
      "Hoy me quedo un momento con la incomodidad, sin retirarme."
    ],
      [
      "Hoy me quedo un momento con la incomodidad, sin retirarme."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué es lo más incómodo de expresar una necesidad?\n[Escribo aquí]",
      "¿Qué ocurre si me quedo con ello un minuto?\n[Escribo aquí]",
      "¿Qué aprendí sobre mi capacidad de tolerarlo?\n[Escribo aquí]"
    ],
      [
      "¿Qué es lo más incómodo de expresar una necesidad?\n[Escribo aquí]",
      "¿Qué ocurre si me quedo con ello un minuto?\n[Escribo aquí]",
      "¿Qué aprendí sobre mi capacidad de tolerarlo?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "La incomodidad es temporal. La supresión es permanente."
    ],
      [
      "Cierre",
      "La incomodidad es temporal. La supresión es permanente."
    ]
    ),
    action: localizedGenderNode(
      "Un minuto de respiración con la incomodidad.",
      "Un minuto de respiración con la incomodidad."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Elegirme sin perder la relación",
    opening: localizedGenderNode(
      [
      "Hoy entiendo que pueden coexistir ambas cosas."
    ],
      [
      "Hoy entiendo que pueden coexistir ambas cosas."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué significa elegirme dentro de una relación?\n[Escribo aquí]",
      "¿Qué valor ya no estoy dispuesto/a a abandonar?\n[Escribo aquí]",
      "¿Qué petición representa ese valor?\n[Escribo aquí]"
    ],
      [
      "¿Qué significa elegirme dentro de una relación?\n[Escribo aquí]",
      "¿Qué valor ya no estoy dispuesto/a a abandonar?\n[Escribo aquí]",
      "¿Qué petición representa ese valor?\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre",
      "Elegirme puede profundizar la conexión."
    ],
      [
      "Cierre",
      "Elegirme puede profundizar la conexión."
    ]
    ),
    action: localizedGenderNode(
      "Escribo mi valor y lo llevo conmigo esta semana.",
      "Escribo mi valor y lo llevo conmigo esta semana."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Cierre suave: una voz que tiene lugar",
    opening: localizedGenderNode(
      [
      "Hoy resumo sin presionarme a actuar de inmediato."
    ],
      [
      "Hoy resumo sin presionarme a actuar de inmediato."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "Me detengo conmigo.",
      "Una respiración. “Mi voz merece espacio”."
    ],
      [
      "Me detengo conmigo.",
      "Una respiración. “Mi voz merece espacio”."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "¿Qué aprendí sobre mí en este recorrido?\n[Escribo aquí]",
      "¿Qué está más claro ahora, aunque duela?\n[Escribo aquí]",
      "Una frase de regreso para días difíciles (corta y clara):\n[Escribo aquí]"
    ],
      [
      "¿Qué aprendí sobre mí en este recorrido?\n[Escribo aquí]",
      "¿Qué está más claro ahora, aunque duela?\n[Escribo aquí]",
      "Una frase de regreso para días difíciles (corta y clara):\n[Escribo aquí]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Cierre final del recorrido",
      "No tengo que gritar para existir.",
      "No tengo que callar para ser amado/a.",
      "Puedo hablar — despacio, con respeto, conmigo.",
      "Y eso es fortaleza."
    ],
      [
      "Cierre final del recorrido",
      "No tengo que gritar para existir.",
      "No tengo que callar para ser amado/a.",
      "Puedo hablar — despacio, con respeto, conmigo.",
      "Y eso es fortaleza."
    ]
    ),
    action: localizedGenderNode(
      "Elijo un pequeño paso futuro donde me daré voz.",
      "Elijo un pequeño paso futuro donde me daré voz."
    ),
  },
].map(buildNormalizedDay);

export const difficultyExpressingNeedsAndBoundariesWithPartnerBlueprintEs = buildNormalizedPilotBlueprint({
  id: "difficulty_expressing_needs_and_boundaries_with_partner_14d",
  version: "tri_locale_emit_es_v1",
  durationDays: 14,
  problemKey: "difficulty_expressing_needs_and_boundaries_with_partner",
  category: "general",
  journeyName: {
    he: "קושי לבטא צרכים וגבולות מול בן/בת הזוג",
    en: "Difficulty Expressing Needs and Boundaries with a Partner",
    es: "Dificultad para expresar necesidades y límites en la pareja",
  },
  days,
});

export default difficultyExpressingNeedsAndBoundariesWithPartnerBlueprintEs;
